import { useDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EListingModalMode } from '../../../actions/listingModal';
import { selectIsDesktopListingVisible } from '../../../selectors/desktopListing';
import { selectModalMode } from '../../../selectors/listingModal';
import { selectResultsJsonQuery } from '../../../selectors/results';
import { TThunkDispatch } from '../../../types/redux';
import { getUxfbViewMode, sendSearchListingUxfbEvent, TUxfbViewMode } from '../../../uxfb/sendUxfbEvents';

export function usePageOpenUxfbEvent(): void {
  const dispatch = useDispatch<TThunkDispatch>();
  const deviceType = useDeviceType();
  const resultsJsonQuery = useSelector(selectResultsJsonQuery);
  const isDesktopListingVisible = useSelector(selectIsDesktopListingVisible);
  const mobileListingModalMode = useSelector(selectModalMode);
  const prevViewMode = React.useRef<TUxfbViewMode | null>(null);

  React.useEffect(() => {
    // На мобвебе PageContainer сразу открывает HALF_SCREEN: стартовый UNSET транзиентный,
    // его map-событие даёт дубль initial search_listing. Позже UNSET (закрытие листинга) шлём.
    const isTransientMobileStart =
      deviceType !== 'desktop' && mobileListingModalMode === EListingModalMode.UNSET && prevViewMode.current === null;

    if (isTransientMobileStart) {
      return;
    }

    const viewMode = getUxfbViewMode(deviceType, isDesktopListingVisible, mobileListingModalMode);

    if (prevViewMode.current === viewMode) {
      return;
    }

    prevViewMode.current = viewMode;

    dispatch(
      sendSearchListingUxfbEvent({
        jsonQuery: resultsJsonQuery,
        deviceType,
      }),
    );
  }, [dispatch, deviceType, resultsJsonQuery, isDesktopListingVisible, mobileListingModalMode]);
}
